export default __webpack_public_path__ + "static/media/neu.80e66a14.png";